module.exports = __webpack_public_path__ + "img/eraser.34f9880f.png";